function Error () {
  return <h1 className="text-[4vw]/[5vw]" >404 Error</h1>
}

export default Error